import { render } from "./About.html?vue&type=template&id=1909ed9b&scoped=true&ts=true&external"
import script from "./About.ts?vue&type=script&lang=ts&external"
export * from "./About.ts?vue&type=script&lang=ts&external"

import "./About.scss?vue&type=style&index=0&id=1909ed9b&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1909ed9b"]])

export default __exports__